"use client";
import ICMWrapper from "@/app/components/icm-wrapper";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb";
import InvestJourney from "@/app/global/components/invest-journey";
import HowToInvest from "@/app/global/components/how-to-invest";
import Faq from "@/app/components/faq";
import { Suspense } from "react";
import { Footer } from "@/app/components/icm 3.0/shared/footer/Footer";
// import { Footer } from "@/app/components/footer";
import { productRoute, ProductRoute /* , ProductType */ } from "@/types/product";
import { InvestmentOptions } from "@/app/interface/platform";
import USStocksHero from "@/app/global/components/us-stock-hero";
import { UsStockListApiResponse } from "@/app/interface/global";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import WhyUsStocks from "@/app/global/components/why-us-stocks";
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import GlobalInvest from "@/app/global/components/global-invest";
import BrowseStocks from "@/app/global/components/browse-stocks";
import WhyInvest from "@/app/global/components/why-invest";
import SquareOneHeartPlusPlus from "@/app/assets/icons/square-one-heart-plus-plus";
import WhyShouldEtfs from "@/app/global/components/why-should-etfs";
// import DownloadAppPlusIconsWhite from "@/app/global/components/download-app-plus-icons-white";

interface Props {
    initialData: UsStockListApiResponse;
    pageRoute: ProductRoute;
}

export default function PageClient({ initialData, pageRoute }: Props) {
    return (
        <Suspense>
            {pageRoute === productRoute["us-stocks"] && (
                <>
                    <ICMWrapper>
                        <Breadcrumb
                            paths={
                                [
                                    { label: "Home", route: "/" },
                                    { label: InvestmentOptions.USStocks },
                                ] as BreadcrumbPath[]
                            }
                        />
                        <USStocksHero
                            redirectTo={`${process.env.ICM_GLOBAL_URL}/login`}
                            stockList={initialData}
                            pageRoute={pageRoute}
                        />
                    </ICMWrapper>

                    {/* <div className="hidden text-center md:my-20 md:block">
                        <RegularButton
                            noIcon
                            showRightIcon={true}
                            rightIcon={<DownloadAppPlusIconsWhite />}
                            size={ButtonSize.Large}
                            variant={ButtonVariant.PrimaryDefault}
                            className="m-auto"
                            label={"Download the app"}
                            onClick={() =>
                                setAnalyticsEvent("", "US_Stocks_Download_the_App_Fold1")
                            }
                        />
                    </div> */}

                    <BrowseStocks pageRoute={pageRoute} />

                    <WhyUsStocks pageRoute={pageRoute} />

                    <WhyInvest pageRoute={pageRoute} />

                    <HowToInvest pageRoute={pageRoute} />

                    <GlobalInvest />

                    <Faq bgColor="bg-[#F4F4F7]" compact={false} product="usStocks" />

                    <InvestJourney pageRoute={pageRoute} />

                    <Footer active={InvestmentOptions.Global} />
                </>
            )}

            {pageRoute === productRoute["us-etfs"] && (
                <>
                    <ICMWrapper>
                        <Breadcrumb
                            paths={
                                [
                                    { label: "Home", route: "/" },
                                    { label: InvestmentOptions.USEtf },
                                ] as BreadcrumbPath[]
                            }
                        />
                        <USStocksHero
                            redirectTo={`${process.env.ICM_GLOBAL_URL}/login`}
                            stockList={initialData}
                            pageRoute={pageRoute}
                        />
                    </ICMWrapper>

                    {/* <div className="hidden text-center md:my-20 md:block">
                        <RegularButton
                            noIcon
                            showRightIcon={true}
                            rightIcon={<DownloadAppPlusIconsWhite />}
                            size={ButtonSize.Large}
                            variant={ButtonVariant.PrimaryDefault}
                            className="m-auto"
                            label={"Download the app"}
                            onClick={() =>
                                setAnalyticsEvent("", "US_Stocks_Download_the_App_Fold1")
                            }
                        />
                    </div> */}

                    <div className="flex flex-col items-center justify-center bg-[#6B929C] md:flex-row md:items-start md:px-s10 md:pb-s19 md:pt-s20">
                        <div className="order-2 flex max-w-[590px] flex-col p-12 pt-0 md:order-1 md:mr-5 md:p-0">
                            <h2 className="mb-3 text-4xl font-semibold leading-[130%] tracking-[-1.5%] text-white">
                                What Are US ETFs?
                            </h2>
                            <p className="text-lg font-medium leading-[164%] tracking-[-1%] text-white">
                                US ETFs (Exchange Traded Funds) allow investors to access a basket
                                of companies, sectors, themes, or asset classes through a single
                                investment product.
                                <br />
                                Instead of selecting individual stocks, ETFs provide exposure to
                                broader market opportunities in a more structured way.
                            </p>
                        </div>
                        <SquareOneHeartPlusPlus className="order-1 w-3/5 md:order-2 md:-mt-4 md:w-auto" />
                    </div>

                    <WhyShouldEtfs pageRoute={pageRoute} />

                    <HowToInvest pageRoute={pageRoute} />

                    <WhyInvest pageRoute={pageRoute} />

                    <Faq bgColor="bg-[#F4F4F7]" compact={false} product="usEtf" />

                    <InvestJourney pageRoute={pageRoute} />

                    <Footer active={InvestmentOptions.Global} />
                </>
            )}
        </Suspense>
    );
}
